"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ModalProvider = exports.ModalDismissDelay = void 0;
exports.useModal = useModal;
var _jsxRuntime = require("@emotion/react/jsx-runtime");
var React = _interopRequireWildcard(require("react"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const modalContext = /*#__PURE__*/React.createContext({
  showModal: () => {
    // do nothing.
  },
  hideModal: () => {
    // do nothing.
  },
  isRootContext: true
});
var ModalDismissDelay;
(function (ModalDismissDelay) {
  ModalDismissDelay[ModalDismissDelay["FIVE_SECONDS"] = 5] = "FIVE_SECONDS";
})(ModalDismissDelay || (exports.ModalDismissDelay = ModalDismissDelay = {}));
function useModal() {
  const context = React.useContext(modalContext);
  if (context.isRootContext) {
    throw new Error('useModal must be used within a ModalProvider');
  }
  return context;
}
const ModalProvider = ({
  children,
  onUpdate
}) => {
  const [modal, setModal] = React.useState();
  const [isShowing, setIsShowingState] = React.useState(false);
  const setIsShowing = React.useCallback(isShowing => {
    onUpdate?.(isShowing);
    setIsShowingState(isShowing);
  }, [onUpdate]);
  const showModal = (_modal, durationUntilDismiss, cb) => {
    setModal(_modal);
    setIsShowing(true);
    if (durationUntilDismiss) {
      setTimeout(() => {
        setIsShowing(false);
        if (cb) {
          cb();
        }
      }, durationUntilDismiss * 1000);
    }
  };
  const hideModal = () => {
    setIsShowing(false);
  };
  // This hides the scrollbar of the page that's behind the modal
  React.useEffect(() => {
    if (isShowing) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.removeProperty('overflow');
    }
  }, [isShowing]);
  return (0, _jsxRuntime.jsxs)(modalContext.Provider, {
    value: {
      showModal,
      hideModal,
      isRootContext: false
    },
    children: [isShowing && modal, children]
  });
};
exports.ModalProvider = ModalProvider;